export default "__VITE_ASSET__DBpX3Lf1__"